import moment from 'moment-timezone';

import { AgentEngagementEventCategoryNoteType } from './agent-engagement-event-category-suggested-note-type';
import { ViewAgentEngagementEventContract } from './view-agent-engagement-event-contract';

export class ViewAgentEngagementEvent {
	public id: number;
	public agentId: string;
	public contractId: string;
	public contractNum: string;
	public contractDisplayStatus: string;
	public agentEngagementEventCategoryId: number;
	public agentEngagementEventStatusId: number;
	public agentEngagementEventCategoryName: string;
	public addDate: Date;
	public agentName: string;
	public agentAddDate: Date;
	public agentIsActive: boolean;
	public agentDeactivationDate: Date;
	public enterpriseId: string;
	public parentId: string;
	public parentName: string;
	public parentContactName: string;
	public parentPhone: string;
	public parentEmail: string;
	public eventDetail: string;
	public followUpDate: Date;
	public isActivated: boolean;
	public agentTotalTermValue: number;
	public lastConfirmationDate: Date;
	public contractStatus: number;
	public isResidential: boolean;
	public numContracts: number;
	public contractTotalTermValue: number;
	public hasAction: boolean;
	public totalElectricityUsage: number;
	public totalNaturalGasUsage: number;
	public commissionRate: number;
	public payableTermValue: number;

	public noteTypes: AgentEngagementEventCategoryNoteType[];
	public viewAgentEngagementEventContracts: ViewAgentEngagementEventContract[];

	// internal
	public eventDetailsJson: any;
	public settingToDone: boolean;
	public settingToActive: boolean;
	public churnStatusSort: number;

	constructor(viewAgentEngagementEvent: ViewAgentEngagementEvent) {
		Object.assign(this, viewAgentEngagementEvent);
		this.followUpDate = this.followUpDate ? new Date(moment(this.followUpDate).format('MMM DD, YYYY 00:00:00 a')) : this.followUpDate;
		this.addDate = this.addDate ? new Date(moment(this.addDate).format('MMM DD, YYYY 00:00:00 a')) : this.addDate;
		this.lastConfirmationDate = this.lastConfirmationDate
			? new Date(moment(this.lastConfirmationDate).format('MMM DD, YYYY 00:00:00 a'))
			: this.lastConfirmationDate;
		this.agentAddDate = this.agentAddDate ? new Date(moment(this.agentAddDate).format('MMM DD, YYYY 00:00:00 a')) : this.agentAddDate;
		this.agentDeactivationDate = this.agentDeactivationDate
			? new Date(moment(this.agentDeactivationDate).format('MMM DD, YYYY 00:00:00 a'))
			: this.agentDeactivationDate;
		const emails = this.parentEmail?.split(';') || [];
		this.parentEmail = emails?.length ? emails[0] : '';
		this.viewAgentEngagementEventContracts = this.viewAgentEngagementEventContracts
			? this.viewAgentEngagementEventContracts.map(c => new ViewAgentEngagementEventContract(c))
			: this.viewAgentEngagementEventContracts;

		this.eventDetailsJson = this.eventDetail ? JSON.parse(this.eventDetail) : null;

		// flip the churn prediction because the orderBy in setTopEvent() cannot have a
		// dynamic ordering direction to separate between the isDormant and isActivated scenarios
		if (this.eventDetailsJson?.hasOwnProperty('churnPrediction')) {
			this.eventDetailsJson.churnPrediction = 100 - this.eventDetailsJson.churnPrediction;
		}

		this.churnStatusSort = this.getChurnSort();

		if (this.numContracts === 1) {
			this.isResidential = Boolean(this.isResidential);
			this.contractStatus = Number(this.contractStatus);
		}

		if (this.eventDetailsJson?.hasOwnProperty('suggestedMargin')) {
			for (const noteType of this.suggestedNoteTypes) {
				noteType.noteType.details = noteType.noteType.details?.replace('{SuggestedMargin}', this.eventDetailsJson.suggestedMargin);
			}
		}
	}

	get suggestedNoteTypes(): AgentEngagementEventCategoryNoteType[] {
		return this.noteTypes?.filter(nt => nt.isSuggested) || [];
	}

	get agentAddDateYears(): number {
		return moment().diff(moment(this.agentAddDate), 'years');
	}

	get agentAddDateMonths(): number {
		return moment().diff(moment(this.agentAddDate), 'months') % 12;
	}

	private getChurnSort(): number {
		if (this.isActivated) {
			return 1;
		} else {
			if (this.eventDetailsJson?.isDormant) {
				return 3;
			}

			return 2;
		}
	}
}
